import React from 'react'
import { Table, Menu, ActionIcon, Text } from '@mantine/core'
import { IconDotsVertical, IconTrash, IconPencil } from '@tabler/icons-react' 

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={150} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit FAQ
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableFaq = ({ label, data, actionMethod }) => {

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td lineClamp={2}>{val.question}</Table.Td>
        <Table.Td lineClamp={2}>{val.answer}</Table.Td>
        <Table.Td lineClamp={2}>
          {val.keyword.map((keyword, idx) => (
            <Text component='span' fz={13} key={idx}>
              {keyword}{idx < val.keyword.length - 1 ? ', ' : ''}
            </Text>
          ))}
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableFaq